import { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import { RadioGroup, InputField } from '@ets/design-system';

type RadioButtonsFieldProps = {
  options: {
    label: string;
    id: string;
  }[];
  value: {
    label: string;
    id: string;
  };
  setValue: (v: { label: string; id: string }) => void;
  label: string;
  margin?: CSSProperties['margin'];
  testId: string;
  isDisabled: boolean;
};

const RadioButtonsField = ({
  options,
  value,
  setValue,
  label,
  margin,
  testId,
  isDisabled,
}: RadioButtonsFieldProps) => {
  const intl = useIntl();
  return (
    <>
      <InputField
        size="l"
        label={intl.formatMessage({ id: label })}
        style={{ margin }}
        testId={testId}
        disabled={isDisabled}
        renderFeedbackIfEmpty={false}
      >
        <RadioGroup
          value={value.id}
          onChange={(e) => {
            setValue({
              id: e.target.value,
              label: options.find((o) => o.id === e.target.value)?.label as string,
            });
          }}
          items={options.map(({ id, label }) => ({ value: id, label }))}
          size="xs"
          direction="vertical"
          testId={testId}
          disabled={isDisabled}
        />
      </InputField>
    </>
  );
};

export default RadioButtonsField;
